// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Menu, Button } from 'semantic-ui-react'

export default class SideBarMenu extends Component {
  render () {
    return (
      <Menu
        vertical
        borderless
        inverted
        fluid
        style={{
          border: 'none',
          borderRadius: 0,
          boxShadow: 'none',
          marginBottom: '0em',
          backgroundColor: '#000'
        }}>
        <Menu.Item href='/'>Home</Menu.Item>
        <Menu.Item href='/pricing'>Pricing</Menu.Item>
        <Menu.Item href='/contact'>Contact</Menu.Item>
        <Menu.Item href='/about'>About</Menu.Item>
        <Menu.Item href='/blog'>Blog</Menu.Item>
        <div className='mt'>
          <Button inverted href='/login'>
            Account
          </Button>
        </div>
      </Menu>
    )
  }
}
